import { useEffect } from 'react';

interface SEOJsonLDProps {
  schema: Record<string, unknown>;
  id?: string;
}

export default function SEOJsonLD({ schema, id = 'json-ld-main' }: SEOJsonLDProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema, null, 2);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
